import React from 'react'
import { useState } from 'react';
import { useNavigate } from "react-router";
import { setReportName, setStateLoaded } from "../../store/store";
import { getXmlHandles, openDirectory, setDirHandles } from '../../helpers/fileHelpers';
import { loadAppraisal } from '../../helpers/loadAppraisal';
import ChooseFileModal from '../common/ChooseFileModal';
import ShowErrorsModal from '../common/ShowErrorsModal';
import { Link } from 'react-router-dom';

export default function HOME() {
  const [filesPopup, setFilesPopup] = useState({ show: false, xmlHandles: [] });
  const [errorsPopup, setErrorsPopup] = useState({ show: false, error: "", errors: [] });
	let navigate = useNavigate();
	
	global.ptr.reset();
	setStateLoaded(false);
	//console.log("Home: ", loaded);

	setReportName('');
	var xmlHandles = [];

	async function openReportFiles() {
		var dirHandles = await openDirectory(window);
		if (!dirHandles) return;

		setDirHandles(dirHandles);
		xmlHandles = getXmlHandles(dirHandles);
		if (xmlHandles.length !== 1) {
			//alert("More than ONE XML file selected");
			setFilesPopup({show: true, xmlHandles: xmlHandles});
			return;
		} else {
			let loaded = await loadAppraisal(xmlHandles[0])
			if (!loaded) {
				setErrorsPopup({show: true, error: "The file selected failed to load.", errors: global.ptr.errors});
				return;
			}

			navigate( '/report');
		}
	}

	async function handleFilesChoose(xHandle) {
		//console.log("File chosen:", xHandle);
		setFilesPopup({show: false});
		let loaded = await loadAppraisal(xHandle)
		if (!loaded) return;

		console.log("navigate to report: ", xHandle.name)
		navigate( '/report');
		return;
	}

	function handleFilesCancel() {
		setFilesPopup({show: false});
		return;
	}

	function handleErrorsChoose() {
		setErrorsPopup({show: false});
		return;
	}

	function handleErrorsCancel() {
		setErrorsPopup({show: false});
		return;
	}

	return (
		<div className="mt-[72px] flex flex-col justify-center">
				<ShowErrorsModal
					open = {errorsPopup.show}
					error = {errorsPopup.error}
					errors = {errorsPopup.errors}
					onChoose={(x) => handleErrorsChoose(x)}
					onCancel={() => handleErrorsCancel()}
				/>
				<ChooseFileModal
					open={filesPopup.show}
					xmlHandles={filesPopup.xmlHandles}
					onChoose={(x) => handleFilesChoose(x)}
					onCancel={() => handleFilesCancel()}
				/>
				<div className="text-center text-xl font-semibold pt-10">
					This program displays a MISMO Version 3.6 XML Appraisal Report
					<br />
					<br />
					Use the button below to select the XML file to view.
				</div>
				<div className="flex justify-center font-semibold pt-6">
					<button 
						className="bg-gray-300 rounded-md p-2 hover:cursor-pointer" 
						onClick={() => openReportFiles()} 
						>
							Select MISMO XML Appraisal Report File Directory
						</button>
				</div>
				<div className="w-full pt-10 flex flex-row justify-center">
					<div className='flex flex-col w-8/12' >
						<div className='text-xl font-semibold'>
							The application requires access to the Appraisal XML file and all the associated images. 
							Choose the directory that contains the desired XML file. The images for the desired report must be in that
							directory or any subdirectories, such as an Image subdirectory. If the images are not available or not found, 
							the report will be displayed without them.
						</div>
						<div className='text-xl font-semibold mt-4'>
							<b>Note: </b>This application is a Progressive Web Application (PWA). A PWA runs completely
							on the client side. No data is ever sent to the server. Also, a PWA can be installed as an application
							and run without an internet connection.
							<br /><br />
							To install, look for the install icon in the URL bar of the browser and click on it.
						</div>
					</div>
				</div>
				<div className='w-full flex justify-center pt-10'>
					{/* <img src={require('images/app-install.png')} /> */}
				</div>
				<div className='w-full flex flex-col text-center font-semibold justify-center pt-10'>
					<div className='text-center text-xl mt-10'>
					Select the link below to download the UAD sample scenarios and XML files<br />
					</div>
					<div className='w-full flex justify-center mt-6'>
						<Link to="https://singlefamily.fanniemae.com/media/document/zip/appendix-d-1-urar-sample-scenarios-and-xml-files" 
							className = 'h-10 w-fit bg-gray-300 rounded-md p-2 hover:cursor-pointer'
							alt = '' 
							>
							Appendix D-1: URAR Sample Scenarios and XML Files
						</Link>
					</div>
				</div>
				<div className="w-full pt-10 flex flex-row justify-center">
					<div className='flex flex-col w-8/12' >
						<div className='text-xl font-semibold'>
							<b>Note: </b>This application is still under development and there are continuous updates. 
							<br />To make sure you have the latest version, refresh the page, which should cause the latest version to be retrieved.
						</div>
					</div>
				</div>
			</div>
	);
}

